import {TaskList, TaskListUnit} from "../../../../API";

export function getLogicalDay(targetDate: Date, unitTimezone: string, shiftHours: number = 4): Date {
    // Convert UTC `now` to local time in unit's timezone
    const local = new Date(targetDate.toLocaleString('en-US', { timeZone: unitTimezone }));

    if (local.getHours() < shiftHours) {
        local.setDate(local.getDate() - 1);
    }

    // Optional: zero out time
    local.setHours(0, 0, 0, 0);

    return local;
}

export function haveLists(taskListUnit: TaskListUnit) {
    if (!taskListUnit || !taskListUnit.taskLists) {
        return false;
    }
    return Object.values(taskListUnit.taskLists).some(list => !(list as TaskList).deletedAt);
}
